import React, { useState } from 'react';
import { apiPost } from '../../utils/api';
import { Copy, Palette } from 'lucide-react';
import { toast } from 'react-hot-toast';

const AsciiArtGenerator = () => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    setResult('');
    try {
      const data = await apiPost('/api/text/ascii-art-generator', { text: input });
      setResult(data.asciiArt);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    toast.success('Resultado copiado!');
  };

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6 mt-6">
      <div className="flex items-center gap-2 mb-4">
        <Palette className="w-6 h-6 text-gray-700" />
        <h1 className="text-2xl font-bold text-gray-900">Gerador de ASCII Art</h1>
      </div>
      <p className="text-gray-700 mb-4">Crie arte com caracteres a partir de texto. Exemplo: transforme "nServers" em um logo estilizado em ASCII.</p>
      <textarea
        className="w-full border rounded p-2 mb-4 text-gray-900 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
        rows={3}
        placeholder="Digite o texto para gerar ASCII Art..."
        value={input}
        onChange={e => setInput(e.target.value)}
      />
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded transition mb-4 flex items-center gap-2 disabled:opacity-60"
        onClick={handleGenerate}
        disabled={!input.trim() || loading}
      >
        {loading && <span className="loader border-white" />}
        Gerar
      </button>
      {result && (
        <div className="mt-4 bg-gray-50 border rounded p-4 flex items-center justify-between overflow-x-auto">
          <pre className="text-gray-900 break-all whitespace-pre-wrap w-full">{result}</pre>
          <button onClick={handleCopy} className="ml-4 text-blue-600 hover:text-blue-800" title="Copiar resultado">
            <Copy className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default AsciiArtGenerator; 